import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TSource } from '@core/types/tsource';
import { ImageCardImports } from '@shared/card/image-card/image-card.imports';
import { ICardImages } from '@shared/db/card.interface';

@Component({
  selector: 'noda-image-card',
  standalone: true,
  templateUrl: './image-card.component.html',
  styleUrls: ['./image-card.component.scss'],
  imports: ImageCardImports,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageCardComponent {
  @Input() public item: ICardImages;
  @Input() public haveExpandedSources: boolean = false;
  @Input() public src: TSource = 'origin';
}
